module.exports = __webpack_public_path__ + "static/q2_x-db245de517093a43584f4722de6c93cf.png";